import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPosterOrder, IPosterOrderItem } from '../../../../../../../../common/common-interfaces/poster-order';
import { availableSkuInfoByPosterType, productNamesBySKU } from '../../../../../../../../common/common-helpers/sku';

@Component({
    selector: 'order-item-administration',
    templateUrl: './order-item-administration.component.html',
    styleUrls: ['./order-item-administration.component.scss'],
    standalone: false
})
export class OrderItemAdministrationComponent {
    @Input()
    order: IPosterOrder;
    @Input()
    item: IPosterOrderItem;
    @Input()
    showSku: boolean = false;

    availableSkuInfoByPosterType = availableSkuInfoByPosterType;

    useAsPrintFile: boolean = false;
    itemInfo: any = {};

    productNamesBySKU = productNamesBySKU;
    constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

    }

    async ngOnInit() {
        if (this.item.status == 'UNKNOWN') {
            this.itemInfo = {
                isStockItem: false,
                posterType: 'POSTER',
                location: 'FRONT',
                sku: '',
            };
        }
    }


    bildbyranOriginalUrl() {
        return this.api.storeUrl(`/poster-orders/${this.order._id}/items/${this.item.identifier}/bildbyran-original`);
    }

    async printFileAdded(data: { order: IPosterOrder, orderItem: IPosterOrderItem }) {
        console.log('Print file added');
        // console.log(order);
        // console.log(orderItem);
        // this.item.status = 'READY';
        //  let orderItem = data.order.items.find(item => item.identifier == this.item.identifier);
        if (data.orderItem) {
            Object.assign(this.item, data.orderItem);
        }
        this.order.status = data.order.status;
    }


    async acceptPrintFile(order: IPosterOrder, item: IPosterOrderItem, approvedByHuman: boolean) {
        let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/${item.identifier}/accept-print-file`, {
            approvedByHuman: approvedByHuman
        });
        if (result.succeeded) {
            Object.assign(order, result.order);
        }
    }

    async addOrderItemInfo(order: IPosterOrder, item: IPosterOrderItem) {
        let itemInfo = this.itemInfo;

        if (this.availableSkuInfoByPosterType[itemInfo.posterType]) {
            let skuInfo = this.availableSkuInfoByPosterType[itemInfo.posterType].find(skuInfo => skuInfo.sku == itemInfo.sku);
            if (skuInfo) {
                itemInfo.size = skuInfo.size;
            }
        }

        if (itemInfo.posterType == 'STOCK_ITEM') {
            itemInfo.isStockItem = true;
        }

        let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/${item.identifier}/add-info`, itemInfo);
        if (result.succeeded) {
            Object.assign(item, result.orderItem);
        }
    }

    async deleteOrderItem(order: IPosterOrder, item: IPosterOrderItem) {
        let result = await this.api.store().delete<any>(`/poster-orders/${order._id}/items/${item.identifier}`);
        if (result.succeeded) {
            Object.assign(order, result.order);
        }
    }

    async posterTypeChanged(order: IPosterOrder, item: IPosterOrderItem) {

    }

    async skuChanged(order: IPosterOrder, item: IPosterOrderItem) {

    }

    async makeItemUnknown(order: IPosterOrder, item: IPosterOrderItem) {
        item.status = 'UNKNOWN';
        item.posterId = null;
        item.printFileUrl = null;
        item.printFileId = null;
        item.mockupImageUrl = null;
        item.sku = null;

        this.itemInfo = {
            isStockItem: false,
            posterType: 'POSTER',
            location: 'FRONT', // Default location for clothes
            sku: '',
        };

        let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/${item.identifier}/make-unknown`, {});
    }




    async search() {


    }



}


